/**
 * MC Axeptio — retire la pastille jaune flottante d'Axeptio.
 *
 * Demande cliente : une fois le choix cookies fait, la pastille restait collée
 * en bas à gauche de l'écran, par-dessus le bouton d'appel à l'action de la
 * page d'accueil.
 *
 * On n'y touche NI en CSS NI dans le DOM : la pastille vit dans un shadow DOM,
 * avec des classes générées (styled-components) qui changent à chaque version
 * d'Axeptio — toute règle CSS serait hors de portée, et tout sélecteur écrit à
 * la main casserait à la prochaine mise à jour. Axeptio expose pour ça une
 * fonction publique, `window.hideAxeptioButton()` : c'est elle qu'on appelle.
 *
 * Ce qui n'est PAS masqué : la bannière de consentement elle-même, qui continue
 * de s'afficher normalement aux nouveaux visiteurs. Seul le bouton de
 * réouverture disparaît — il est remplacé par le lien « Gérer mes cookies » du
 * pied de page (voir sections/MM-Footer.liquid), pour que revenir sur son choix
 * reste possible et aussi simple que de le donner.
 *
 * Réglage définitif possible sans code : la même option existe côté Axeptio
 * (paramètre `hideAxeptioButton` de la configuration du widget). Si elle est
 * activée dans leur back-office, ce fichier devient superflu.
 */
(function () {
	'use strict';

	var LINK = '[data-mc-cookies]';

	function hideBadge() {
		if (typeof window.hideAxeptioButton !== 'function') return false;
		window.hideAxeptioButton();
		return true;
	}

	/* Le lien du pied de page n'apparaît que si Axeptio répond : pas de bouton
	   mort si le script est bloqué (adblock) ou retiré du site. */
	function revealLinks() {
		if (typeof window.openAxeptioCookies !== 'function') return;
		var links = document.querySelectorAll(LINK);
		for (var i = 0; i < links.length; i++) links[i].hidden = false;
	}

	document.addEventListener('click', function (event) {
		var link = event.target.closest && event.target.closest(LINK);
		if (!link) return;
		event.preventDefault();
		if (typeof window.openAxeptioCookies === 'function') window.openAxeptioCookies();
	});

	/* Axeptio est chargé de façon asynchrone (par GTM ici) : on réessaie
	   jusqu'à ce que son API réponde, puis on s'arrête. */
	var tries = 0;
	var timer = window.setInterval(function () {
		tries += 1;
		var ready = hideBadge();
		if (ready) revealLinks();
		if (ready || tries > 60) window.clearInterval(timer);
	}, 500);

	/* File d'attente officielle d'Axeptio : la pastille est remise en place
	   après chaque nouveau consentement, on la remasque à ce moment-là. */
	window._axcb = window._axcb || [];
	window._axcb.push(function (sdk) {
		hideBadge();
		revealLinks();

		if (sdk && typeof sdk.on === 'function') {
			sdk.on('cookies:complete', function () {
				hideBadge();
				revealLinks();
			});
			sdk.on('close', hideBadge);
		}
	});
})();
